import React from 'react'

function Input({ no_rounded = false, type = "text", ...rest }) {
    return (
        <div className='w-full '>
            <input
                {...rest}
                type={type}
                className={`py-3 px-5 w-full outline-none transition-all
                    ${no_rounded ? "rounded-lg" : 'rounded-full'} border text-base focus:border-black`}
            />
        </div>
    )
}

export default Input